<div mat-dialog-title class="dialog-title">
  <eon-ui-icon fxLayout fxLayoutAlign="end" [mat-dialog-close]="{status: 'closed'}" class=closeX
               name="close"></eon-ui-icon>
  <div class="headline">Choose unit</div>

</div>

<div mat-dialog-content class="dialog-content">


  <div class="margin-bottom-24">No unit for data point ( {{datapointName}} ) found on OPC UA server, please select a unit from the list:</div>


  <mat-grid-list [cols]="3" rowHeight="50px" gutterSize="50px">

    <!--    Select Unit-->
    <mat-grid-tile> Select Unit:</mat-grid-tile>

    <mat-grid-tile>
      <div>
        <mat-form-field>
          <mat-select [(value)]="selectedUnit">
            <mat-option value="none">None</mat-option>
            <mat-option *ngFor="let unit of unitConversionList" [value]="unit.endUnit">{{ unit.endUnit }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-grid-tile>

    <!--    Reset to None button-->
    <mat-grid-tile>
      <eon-ui-button [text]="'Reset to None'"
                     scheme="red"
                     rank="secondary"
                     (click)="resetUnit()"></eon-ui-button>
    </mat-grid-tile>

    <!--  Factor dropdown -->
    <mat-grid-tile> Factor:</mat-grid-tile>

    <mat-grid-tile>
      <div>
        <mat-form-field>
          <!--        <mat-label>Clearable input</mat-label>-->
          <input matInput type="number" [(ngModel)]="factorValue">
        </mat-form-field>
      </div>
    </mat-grid-tile>

    <!--    Factor tooltip-->
    <mat-grid-tile>
      <div class="tooltip-div">
        <eon-ui-info-icon>
          <eon-ui-tooltip slot="tooltip" placement="bottom">
            <eon-ui-text text-style="subheadline">Add factor to convert unit on OPCUA server to target unit in e.IoT.
            </eon-ui-text>
            <eon-ui-text text-style="abstract"> (e.g. value in MWh * factor = value in kWh )</eon-ui-text>
          </eon-ui-tooltip>
        </eon-ui-info-icon>
        <span>{{ 'general.help' | translate }}</span>
      </div>
    </mat-grid-tile>

    <!-- empty row-->
    <mat-grid-tile [colspan]="2"></mat-grid-tile>
    <mat-grid-tile [colspan]="2"></mat-grid-tile>

  </mat-grid-list>


  <div mat-dialog-actions style="justify-content: space-between;">
    <eon-ui-button [text]="'general.close' | translate"
                   scheme="red"
                   (click)="closeDialog()"></eon-ui-button>

    <eon-ui-button [text]="'general.save' | translate"
                   scheme="red"
                   (click)="save()"></eon-ui-button>

    <!--  <eon-ui-button [text]="'Reset to None'"-->
    <!--                 scheme="red"-->
    <!--                 rank="secondary"-->
    <!--                 (click)="resetUnit()"></eon-ui-button>-->
  </div>
</div>
